export const IMG_URL='IMG_URL' 
export const NEW_LIST='NEW_LIST'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js